(ns manatee.admin.users.app-db
  "App. DB support for the admim. users tab."
  (:require
   [manatee.admin.app-db :as admin-db]))

(def ^:private users-tab-path
  (conj admin-db/root-path :users-tab))

(def ^:private list-view?-path
  (conj users-tab-path :list-view?))

(defn list-view?
  [db]
  (get-in db list-view?-path true))

(defn set-list-view
  [db flag]
  (assoc-in db list-view?-path flag))
